<template>
  <el-dialog custom-class="reset-dialog-container" :show-close="false" width="544px" v-model="visible"
             @close="visible = false" top="84px" center>
    <template #title>
      <div class="dialog-header">{{t('global.bindEmailDialog.title.text_1')}}</div>
    </template>
    <div class="dialog-body">
      <el-form :model="formReq.fields" :rules="formReq.rules" ref="formReqRef" label-width="160px" label-position="right">
        <el-form-item :label="t('global.bindEmailDialog.content.text_1')">
          <div class="phone-wrap">{{userInfo?.mobile?.replace(/(?=(\d{4})+$)/g,' ')||''}}</div>
        </el-form-item>
        <el-form-item prop="email" :label="t('global.bindEmailDialog.content.text_2')">
          <el-input v-model="formReq.fields.email" :placeholder="formReq.schema.email.label" @blur="handleEmailBlur"/>
        </el-form-item>
        <el-form-item prop="emailCode" :label="t('global.bindEmailDialog.content.text_3')">
          <div class="send-code-wrap">
            <el-input v-model="formReq.fields.emailCode" :placeholder="formReq.schema.emailCode.label" />
            <sr-email-code-btn
                :email="formReq.fields.email"
                v-model:email-id="formReq.fields.emailId"
                :disabled="DISABLED.EMAIL_CODE"
                type="3"/>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" @click="handleBind">{{t('global.bindEmailDialog.content.text_4')}}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { ref, toRefs, computed, reactive, watchEffect } from 'vue'
import SrEmailCodeBtn from '@/components/SrEmailCodeBtn'
import { BindEmailReq } from '@/domain/modules/register'
import { useStore } from 'vuex'
import { formComp } from '@/compositions'
import { encryptUtils, commonUtils, vab } from '@libs/utils'
import { bindingEmail } from "@/api/modules/user"
import store from "@/store"
import { useI18n } from "@/plugins/i18n"

export default {
  name: 'BindEmailDialog',
  props: {
    viewVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SrEmailCodeBtn
  },
  emits: ['close'],
  setup(props, ctx) {
    const store = useStore()
    const _initForm = initForm()
    const { t } = useI18n()
    const state = reactive({
      visible: false,
      userInfo: store.state.user.userInfo
    })

    const scopedMethods = {
      dialogClose: () => {
        ctx.emit('close')
      },
      handleBind: () => {
        const form = commonUtils.clone(_initForm.formReq.fields)
        _initForm.formReqRef.value.validate(async valid => {
          if (valid) {
            if (!form.emailId) return vab.baseMessage(t('global.bindEmailDialog.content.text_5'), 'error')
            try {
              await bindingEmail(form)
              await store.dispatch('user/getUserInfo')
              state.visible = false
            } catch {
              state.visible = false
            }
          }
        })
      }
    }

    const scopedComputed = {
      userInfo: computed(() => store.state.user.userInfo)
    }

    watchEffect(() => {
      state.visible = props.viewVisible
    })

    return {
      ...toRefs(state),
      ...scopedComputed,
      ...toRefs(_initForm),
      ...scopedMethods,
      t
    }
  }
}

// 初始化form
const initForm = () => {
  const { createForm } = formComp()
  const state = reactive({
    enabledCfg: {
      email: false
    },
    formReqRef: null,
  })
  const formReq = createForm({ items: BindEmailReq })
  const scopedMethods = {
    handleEmailBlur: () => {
      formReq.fields.email = formReq.fields.email.trim()
      state.formReqRef.validateField('email', message => {
        state.enabledCfg.email = message !== ''
      })
    },
  }

  const scopedComputed = {
    DISABLED: computed(() => {
      return {
        EMAIL_CODE: (() => {
          return state.enabledCfg.email
        })()
      }
    })
  }

  return { ...toRefs(state), formReq, ...scopedMethods, ...scopedComputed }
}
</script>

<style lang="scss" rel="stylesheet/scss">
  .reset-dialog-container {
    .dialog-body {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }

    .el-dialog__header {
      margin: 0;
      padding: 0;
      border-radius: 3px;
      overflow: hidden;
    }

    .dialog-header {
      height: 70px;
      padding-left: 35px;
      background-color: #F5FCFE;
      display: flex;
      align-items: center;
      font-weight: bold;
    }

    .dialog-footer {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;
    }
  }
</style>

<style scoped lang="scss" rel="stylesheet/scss">
  .phone-wrap {
    color: #5DB2E7;
    font-weight: bold;
  }
  :deep(.el-form) {
    width: 100% !important;

    .el-form-item__label {
      padding: 0 30px 0 0 !important;
    }

    .el-form-item__content {
      flex: inherit !important;
      width: auto !important;

      .el-input__inner, .el-textarea__inner {
        width: 288px !important;
        border-radius: 4px !important;
      }

      .send-code-wrap {
        width: 288px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .el-input__inner, .el-textarea__inner {
          width: 170px!important;
        }
      }

      .el-input {
        width: auto;
      }
    }
  }
</style>
